import {
    CONFIRMED_GET_OBJECTION,
    CONFIRMED_CREATE_OBJECTION,
    CONFIRMED_DELETE_OBJECTION,
    CONFIRMED_EDIT_OBJECTION
} from "../types/ObjectionTypes";

import {
    getObjections,
    addObjection,
    updateObjection,
    deleteObjection,
    formatObjections,
} from "../../services/ObjectionService";

import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get list
export function getObjectionAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
) {
    return async (dispatch) => {
        try {
            const response = await getObjections(
                pagination,
                pageid,
                search_by,
                search_keyword,
                sort_by,
                sort_order
            );

            if (response?.status === 200 && response.data?.status === "success") {
                const list = formatObjections(response.data.data);
                const num_rows = response.data.num_rows || 0;

                dispatch({
                    type: CONFIRMED_GET_OBJECTION,
                    payload: { list, num_rows },
                });
            } else {
                handleError("Failed to get Objections");
            }
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to get Objections");
        }
    };
}

// Delete
export function deleteObjectionAction(objectionId) {
    return async (dispatch) => {
        try {
            await deleteObjection(objectionId);
            dispatch({
                type: CONFIRMED_DELETE_OBJECTION,
                payload: { objection_id: objectionId },
            });
            handleSuccess("Objection deleted successfully!");
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to delete ObjectionId");
        }
    };
}

// Create
export function addObjectionAction(objectionData, navigate) {
    return async (dispatch) => {
        try {
            const response = await addObjection(objectionData);

            if (response?.status === 200 && response.data?.status === "success") {
                const formatted = formatObjections([response.data.data])[0];
                dispatch({
                    type: CONFIRMED_CREATE_OBJECTION,
                    payload: formatted,
                });
                if (navigate) navigate("/objections");
                handleSuccess("Objection created successfully!");
            } else {
                showErrorAlert("Failed to create Objection");
            }
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to create Objection");
        }
    };
}

// Update
export function updateObjectionAction(objectionData, objectionId, navigate) {
    return async (dispatch) => {
        try {
            const payload = {
                ...objectionData,
                objection_id: objectionId,
            };

            const response = await updateObjection(payload);

            if (response?.status === 200 && response.data?.status === "success") {
                const formatted = formatObjections([response.data.data])[0];
                dispatch({
                    type: CONFIRMED_EDIT_OBJECTION,
                    payload: formatted,
                });
                if (navigate) navigate("/objections");
                handleSuccess("Objection updated successfully!");
            } else {
                showErrorAlert("Failed to update Objection");
            }
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to update Objection");
        }
    };
}
